import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapDrawbackResponse } from "@/redux/mappers/Export/CreateNewJob/DrawbackMappers";

export const drawBackApi = createApi({
  reducerPath: "drawBackApi",
  baseQuery,
  tagTypes: ["DrawBack"],
  endpoints: (builder) => ({
    // GET
    getDrawBackByMasterId: builder.query({
      query: ({id}) => `export/product/drawback/${id}`,
        transformResponse:(response) => mapDrawbackResponse(response?.data) ?? [],
      providesTags: ["DrawBack"],
    }),

    // CREATE
    createDrawBack: builder.mutation({
      query: ({ id , ...data }) => ({
        url: `export/product/drawback/${id}`,
        method: "PUT",
        body: { drawback:data },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["DrawBack"],
    }),
  }),
});

export const {
  useLazyGetDrawBackByMasterIdQuery,
  useCreateDrawBackMutation,
} = drawBackApi;
